import React from 'react';

const CompanyFormModal = React.lazy(() => import('../components/FormModal'));
const companyModalRegistry = {
    company_companyId: CompanyFormModal
};
export default companyModalRegistry;
